// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const progressRingClasses = {
  bar: "qui-progress-ring__bar",
  circle: "qui-progress-ring__circle",
  circleContainer: "qui-progress-ring__circle-container",
  errorText: "qui-progress-ring__error-text",
  label: "qui-progress-ring__label",
  root: "qui-progress-ring__root",
  track: "qui-progress-ring__track",
  valueText: "qui-progress-ring__value-text",
} as const
